import { Card, CardContent, Typography } from '@growdash/design-system/atoms';
import { cn } from '@growdash/design-system/utils/helpers.js';
import GradientSparkleFilled from '@growdash/growintel/assets/icons/gradient-sparkle.filled';

type Props = {
  title?: string;
  children: React.ReactNode;
  className?: string;
};

export default function AishaCard({
  title = 'Aisha insights',
  children,
  className = '',
}: Props) {
  return (
    <Card className={cn(' backdrop-blur-[13px] shadow-inner', className)}>
      <CardContent>
        <div className="flex gap-2 items-center mb-4">
          <GradientSparkleFilled />
          <Typography className="text-tertiary font-semibold text-xl ">
            {title}
          </Typography>
        </div>
        {children}
      </CardContent>
    </Card>
  );
}
